import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { environment } from '../../../environments/environment';
import { auth, firestore } from '../../../../../../libs/firebase-service/src';
import {
  LoadItems,
  setModifiers,
  LoadCategories,
  ResturantID,
  allactiveMenues,
  menuDocs,
  menues,
  setStores,
  userAddresses,
} from '@tabletuck/redux-slices';
import { homePageEvent } from '../../../libs/models/facebookPixelEvent';

const WebflowRedirect = ({ path = '' }) => {
  const dispatch = useDispatch();
  const [dataLoaded, setDataLoaded] = useState(false);

  const popularCategory = {
    id: 'Popular',
    name: 'Popular',
    description: 'Popular',
    is_deleted: true,
    category_image_thumb_url: 'popularImage',
  };

  const getStores = async () => {
    try {
      let storeRef = firestore.collection('stores');
      storeRef = storeRef.where('is_deleted', '==', false);
      let list = [];
      const StoresList = await storeRef.get();
      for (let index = 0; index < StoresList?.docs?.length; index++) {
        let element = StoresList?.docs[index]?.data();
        element.id = StoresList?.docs[index]?.id;
        list.push(element);
      }
      dispatch(setStores(list));
    } catch (err) {
      // Error handled silently
    }
  };

  const getMenuFirebase = async () => {
    try {
      let menusRef = firestore.collection('menus');
      menusRef = menusRef.where('is_deleted', '==', false);
      const querySnapshot = await menusRef.get();

      const mappedMenus = querySnapshot.docs.map((d) => {
        return {
          id: d.id,
          ...d.data(),
        };
      });
      dispatch(menues([...mappedMenus]));

      const activMenus = mappedMenus
        .filter((item) => item.off_menu === false)
        .map((item) => item.id);
      dispatch(allactiveMenues([...activMenus]));

      querySnapshot.forEach((doc) => {
        dispatch(menuDocs(doc.data()));
      });
    } catch (error) {
      // Error handled silently
    }
  };

  const getItems = async () => {
    try {
      let ItemsRef = firestore.collection('items');
      ItemsRef = ItemsRef.where('is_deleted', '==', false);
      const itemsList = await ItemsRef.where(
        'item_state',
        '==',
        'available'
      ).get();
      const mappedItems = itemsList.docs.map((d) => {
        return {
          id: d.id,
          ...d.data(),
        };
      });
      dispatch(LoadItems([...mappedItems]));
    } catch (err) {
      // Error handled silently
    }
  };

  const getCategories = async () => {
    try {
      let categoryRef = firestore.collection('categories');
      categoryRef = categoryRef.where('is_deleted', '==', false);
      categoryRef = categoryRef.where('enable_items', '==', true);

      const categoriesList = await categoryRef.get();
      const mappedItems = categoriesList.docs.map((d) => {
        return {
          id: d.id,
          ...d.data(),
        };
      });
      dispatch(LoadCategories([popularCategory, ...mappedItems]));
    } catch (err) {
      // Error handled silently
    }
  };

  const getModifiers = async () => {
    try {
      let modifiersRef = firestore.collection('modifier_groups');
      modifiersRef = modifiersRef.where('is_deleted', '==', false);
      const modifierList = await modifiersRef.get();
      const mappedModifier = modifierList.docs.map((d) => {
        return {
          id: d.id,
          ...d.data(),
        };
      });
      dispatch(setModifiers([...mappedModifier]));
    } catch (err) {
      // Error handled silently
    }
  };

  const getUserAddress = async () => {
    try {
      if (auth?.currentUser?.uid) {
        await firestore
          .collection('users')
          .doc(auth.currentUser.uid)
          .collection('addresses')
          .get()
          .then((docs) => {
            let adds = [];
            docs.forEach((doc) => {
              adds.push(doc.data());
            });
            dispatch(userAddresses(adds));
          });
      }
    } catch (e) {
      // Error handled silently
    }
  };

  const loadAllData = async () => {
    try {
      // Execute all Firebase fetch functions in parallel
      await Promise.all([
        getUserAddress(),
        getItems(),
        getCategories(),
        getModifiers(),
        getMenuFirebase(),
        getStores(),
      ]);

      // Execute Facebook pixel event
      homePageEvent();

      setDataLoaded(true);
    } catch (error) {
      setDataLoaded(true); // Still redirect even if there's an error
    }
  };

  useEffect(() => {
    // Skip redirect for .well-known paths (Apple Pay domain verification, etc.)
    const currentPath = window.location.pathname;
    if (currentPath.startsWith('/.well-known/')) {
      return;
    }

    // Only redirect for fatty patty
    if (
      environment?.restaurantId === 'fattyPattyDev' ||
      environment?.restaurantId === 'fattyPatty'
    ) {
      // Load all Firebase data first
      loadAllData();
    }
  }, []);

  useEffect(() => {
    // Skip redirect for .well-known paths (Apple Pay domain verification, etc.)
    const currentPath = window.location.pathname;
    if (currentPath.startsWith('/.well-known/')) {
      return;
    }

    // Redirect after data is loaded
    if (
      dataLoaded &&
      (environment?.restaurantId === 'fattyPattyDev' ||
        environment?.restaurantId === 'fattyPatty')
    ) {
      const baseUrl = 'https://fattypatty.zetaton.dev';
      const fullUrl = path ? `${baseUrl}${path}` : baseUrl;

      // Add a small delay to ensure Redux state is updated
      setTimeout(() => {
        window.location.replace(fullUrl);
      }, 100);
    }
  }, [dataLoaded, path]);

  // Skip rendering for .well-known paths
  const currentPath = window.location.pathname;
  if (currentPath.startsWith('/.well-known/')) {
    return null;
  }

  // Show loading state while loading data and redirecting
  if (
    environment?.restaurantId === 'fattyPattyDev' ||
    environment?.restaurantId === 'fattyPatty'
  ) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontFamily: 'Poppins, sans-serif',
          color: '#1F2937',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              width: '40px',
              height: '40px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #3498db',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto 16px',
            }}
          ></div>
          <p>{!dataLoaded ? 'Loading menu data...' : 'Redirecting...'}</p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  // Return null for other restaurants (this shouldn't render)
  return null;
};

export default WebflowRedirect;
